<c-container class="min-vh-90 pt-8">
  <app-header-guest *ngIf="isGuest; else userHeader"></app-header-guest>
  <ng-template #userHeader>
    <app-header-user></app-header-user>
  </ng-template>
  <div id="content">
    <ng-content></ng-content>
  </div>
</c-container>
